import { CromaiTheme } from './src/styles/theme'
/** @type {import('tailwindcss').Config} */
export default {
  darkMode: 'class',
  content: [
    './index.html',
    './src/**/*.{js,ts,jsx,tsx,mdx}',
    './src/components/**/*.{js,ts,jsx,tsx,mdx}',
    './src/pages/**/*.{js,ts,jsx,tsx,mdx}'
  ],
  theme: {
    extend: {
      extend: {
        transform: {
          'translate-z-0': 'translateZ(0)'
        }
      },
      colors: {
        ...CromaiTheme.CromaiColors
      },
      fontFamily: {
        sans: ['Cabin', 'sans-serif'],
        mono: ['Source Sans Pro', 'sans-serif']
      },
      fontSize: {
        ...CromaiTheme.CromaiFontSize
      },
      boxShadow: {
        ...CromaiTheme.CromaiBoxShadow
      },
      dropShadow: {
        ...CromaiTheme.CromaiDropShadow
      },
      backgroundImage: {
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
        'gradient-conic':
          'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))'
      }
    }
  },
  plugins: []
}
